<template>
  <div class="placeholder">
    <div class="placeholder-inner">
      <div class="placeholder-bg"></div>
      <svg
        :width="width"
        :height="height"
        :viewBox="`0 0 ${width} ${height}`"
        class="placeholder-mask"
      >
        <title></title>
        <g>
          <path
            d="M0 0h1312v216H0V0zm0 0h700v24H0V0zm40 64h476v24H40V64zM0 64h24v24H0V64zm0 64h940v24H0V192z"
            fill="currentColor"
            fill-rule="evenodd"
          ></path>
        </g>
      </svg>
    </div>
  </div>
</template>
<script>
export default {
  name: 'loading',
  data() {
    const dpr = window.devicePixelRatio;
    return {
      width: 1312 * dpr,
      height: 216 * dpr,
    };
  },
};
</script>
<style scoped lang="less">
.placeholder {
  box-sizing: border-box;
  height: 55px;
  position: relative;
  margin: 15px 20px;
}
.placeholder-inner {
  width: 100%;
  position: relative;
  overflow: hidden;
  background: #f6f6f6;
  color: #fff;
}
.placeholder-bg {
  position: absolute;
  width: 200%;
  height: 100%;
  background: linear-gradient(90deg, #f6f6f6 0, #ebebeb 20%, #f6f6f6 40%, #f6f6f6);
  animation: linear-double 1s linear 1ms infinite forwards;
}
.placeholder-mask {
  position: relative;
  min-width: 100%;
  vertical-align: top;
  box-sizing: border-box;
}
@keyframes linear-double {
  0% {
    transform: translateX(-56%);
  }
  to {
    transform: translateX(56%);
  }
}
</style>
